import React, { useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import api from '../../../../api/api';
import { useUserStore } from '../../../../stores/userStore';

export default function HistoricalReviews({ albumId }) {
  const { user } = useUserStore();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const query = useQuery({
    queryKey: ['album-review-history', user?.id, albumId],
    enabled: open && Boolean(user?.id),
    queryFn: async () => (await api.getAuth(`/albums/${albumId}/review-history`)).data.data,
  });
  return (
    <Stack spacing={1} sx={{ my: 2 }}>
      <Button onClick={() => setOpen(!open)} aria-expanded={open}>
        공식 편입 전 내 이전 기록
      </Button>
      {open && (
        <>
          <Typography variant="caption">
            이전 리뷰와 반응은 보존되며 현재 평균에는 포함되지 않습니다.
          </Typography>
          {query.isLoading && <Typography>불러오는 중…</Typography>}
          {query.isError && (
            <Alert
              severity="error"
              action={<Button onClick={() => query.refetch()}>다시 시도</Button>}
            >
              이전 기록을 불러오지 못했습니다.
            </Alert>
          )}
          {query.data?.length === 0 && <Typography>이전 기록이 없습니다.</Typography>}
          {query.data?.map((record) => (
            <Button
              key={record.id}
              disabled={!record.albumSlug}
              onClick={() =>
                navigate(
                  `/reviews/${encodeURIComponent(record.albumSlug)}/user-reviews/${record.id}`,
                )
              }
              sx={{ textAlign: 'left', justifyContent: 'flex-start' }}
            >
              <Stack>
                <Typography>
                  {record.rating.toFixed(1)} · {record.createdAt.slice(0, 10)}
                </Typography>
                <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                  {record.content || '별점 기록'}
                </Typography>
              </Stack>
            </Button>
          ))}
        </>
      )}
    </Stack>
  );
}
